/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';

interface Bounds {
  bottomRightLat?: number;
  bottomRightLong?: number;
  topLeftLat?: number;
  topLeftLong?: number;
}

const MIN_MAP_WIDTH_TO_OMIT_BOUNDS = 90;

const getCurrentBounds = (map: L.Map): Bounds => {
  const bounds = map.getBounds();
  const southEast = bounds.getSouthEast().wrap();
  const northWest = bounds.getNorthWest().wrap();
  const width = Math.abs(bounds.getEast() - bounds.getWest());

  if (width >= MIN_MAP_WIDTH_TO_OMIT_BOUNDS) {
    return {};
  }

  return {
    bottomRightLat: southEast.lat,
    bottomRightLong: southEast.lng,
    topLeftLat: northWest.lat,
    topLeftLong: northWest.lng,
  };
};

export const useBoundsUpdate = (map: L.Map): Bounds => {
  const [bounds, setBounds] = useState<Bounds>(getCurrentBounds(map));

  const handleBoundsChange = (): void => setBounds(getCurrentBounds(map));

  useEffect(() => {
    map.on('dragend', handleBoundsChange);
    map.on('zoomend', handleBoundsChange);

    return () => {
      map.off('dragend', handleBoundsChange);
      map.off('zoomend', handleBoundsChange);
    };
  }, []);

  return bounds;
};
